import React, { useEffect, useRef } from 'react';
import { Circle, Text, Group  } from 'react-konva';
import { useHover } from '../../contexts/HoverContext'; // Import useHover
//import { useData } from '../../contexts/DataContext';
import { useAppData } from "../../hooks/useAppData";
import { useAppStore } from "../../hooks/useAppStore";


const PetButton = ({
    buttonId, 
    buttonLabel = ' ', 
    shapeId, 
    x = 0, 
    y = 0, 
    radius = 10, 
    color = 'transparent', 
    selected, 
    onClick, 
    rotation, 
    onMouseEnter, 
    onMouseLeave, 
    hovered
}) => {
 
    const buttonRef = useRef(null);

    const { 
        handleHoverEnter, 
        handleHoverLeave, 
        hoveredButtonId,
        isDraggingWord,
        draggedWordPosition,
        stageRef
    } = useHover();

    /*const { 
        shapes
    } = useData();*/
     const { shapes } = useAppData();


    const isHovered = (hoveredButtonId === buttonId);

    // Function to get button position in viewport
    const getButtonPositionInViewport = () => {
        if (!buttonRef.current) return null;

        // Get absolute position in Konva stage
        const absolutePos = buttonRef.current.getAbsolutePosition();

        // If you have stageRef, get the bounding box of the stage
        const stageBox = buttonRef.current.getStage().container().getBoundingClientRect();

        return {
            x: stageBox.left + absolutePos.x,
            y: stageBox.top + absolutePos.y,
            radius: radius
        };
    };

    const handleMouseEnter = (e) => {
        e.cancelBubble = true;
        handleHoverEnter(buttonId);
        onMouseEnter(buttonId, e);
    };

    const handleMouseLeave = (e) => {
        e.cancelBubble = true;
        onMouseLeave(buttonId); // Assuming onMouseLeave expects a buttonId
        handleHoverLeave();
    };
    
    const handleButtonClick = (e) => {
        if (isDraggingWord) return;
        e.cancelBubble = true;
        //e.evt.stopPropagation(); // Correctly using stopPropagation()
        // Get the absolute position of the clicked button
        onClick(e, buttonId, shapeId);
    };

    // Detects hover for **both touch & mouse**
    const handleTouchStart = (e) => {
        handleHoverEnter(buttonId); // Treat touch as hover
    };

    const handleTouchEnd = (e) => {
        handleHoverLeave();
    };

    useEffect(() => {
        if (!draggedWordPosition) return;
        
        //const buttonAbsolutePosition = buttonRef.current.getAbsolutePosition();
        // Get stage reference from context 
        const stage = stageRef?.current;
        if (!stage) return;

        // Get the absolute position of the shape
        const shape = shapes.find(shape => shape._id === shapeId);
        if (!shape) return; // Exit if shape is not found

        // Compute absolute button position relative to viewport
        const buttonCenterX = (shape.x + x) + stage.width()/2;
        const buttonCenterY = (shape.y + y) + stage.height()/2;

        //console.log(`📌 Fixed PetButton Position: X=${buttonCenterX}, Y=${buttonCenterY}`);

        // Calculate distance between dragged word and pet button center
        const distance = Math.sqrt(
            (draggedWordPosition.x - buttonCenterX) ** 2 +
            (draggedWordPosition.y - buttonCenterY) ** 2
        );

        //console.log(`📌 Distance to button ${buttonId}:`, distance, "Radius:", radius+20);

        // 🔹 Check if the dragged word is within the button's radius
        if (distance <= radius+20) {
            handleHoverEnter(buttonId);  // Show hover effect
        } else {
            handleHoverLeave();
        }
    }, [draggedWordPosition]); // Update hover when dragged word moves

    return (
        <React.Fragment>
            <Group
            ref={buttonRef}
            x={x}
            y={y}
            //onMouseEnter={handleMouseEnter} // Defined to call setHoveredItem with button's details
            //onMouseLeave={handleMouseLeave}
            onClick={handleButtonClick} // Attaching click event to the group
            onPointerEnter={handleMouseEnter}// Works for both mouse and touch
            onPointerLeave={handleMouseLeave} 
            onPointerUp={handleButtonClick}
            onTouchStart={handleTouchStart}  // Works for mobile
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchEnd}
            >
                <Circle
                    radius={isNaN(radius) ? 10 : radius} // Prevent NaN values, caused issues in Safari
                    fill={isHovered ? '#dc03d1' : color}
                    stroke={isHovered ? '#dc03d1' : (selected ? '#e89b00' : '#808080')}
                    strokeWidth={1.5}
                    shadowColor={selected ? 'red' : 'none'} // Yellow shadow to create a glow effect
                    shadowBlur={selected ? 20 : 0} // Increase blur for a more pronounced glow
                    shadowOffset={{ x: 0, y: 0 }} // No offset to ensure the glow is uniform
                    shadowOpacity={selected ? 0.9 : 0} // Full opacity for the glow effect
                />
                <Text
                    text={buttonLabel} //{buttonLabel? buttonLabel : '+'} to show "+" when button is not assigned a word
                    fontSize={10}
                    fontFamily="Quicksand"
                    rotation={-rotation}
                    offsetX={10} // Offset by half the width to center the text
                    offsetY={5} // Adjust based on font size to center vertically within the circle
                    width={isNaN(radius) ? 10 : radius * 2}                    
                    align="center"
                    verticalAlign="middle"
                />

            </Group>
        </React.Fragment>
    );
};

export default PetButton;
